export default __webpack_public_path__ + "static/media/ic_payment_unselected.c730abe5.svg";